import React, { useLayoutEffect, useRef } from "react";
import classNames from "classnames";
import { Input } from "reactstrap";

const fitHeightToContent = (element) => {
  if (!element) return;

  element.style.height = "auto";
  const borders = element.offsetHeight - element.clientHeight;
  element.style.height = `${element.scrollHeight + borders}px`;
};

// Textarea que arranca con el alto de un input y crece con el contenido.
export default function AutoResizeTextarea({ className, value, ...props }) {
  const textareaRef = useRef(null);

  useLayoutEffect(() => {
    fitHeightToContent(textareaRef.current);
  }, [value]);

  // Al cambiar el ancho (columnas de tabla, ventana) cambia el número de líneas.
  useLayoutEffect(() => {
    const element = textareaRef.current;
    const ResizeObserverImplementation = window.ResizeObserver;
    if (!element || !ResizeObserverImplementation) return undefined;

    let lastWidth = element.clientWidth;
    const observer = new ResizeObserverImplementation(() => {
      if (element.clientWidth === lastWidth) return;
      lastWidth = element.clientWidth;
      fitHeightToContent(element);
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <Input
      {...props}
      type="textarea"
      rows={1}
      value={value}
      innerRef={textareaRef}
      className={classNames("dhn-auto-resize-textarea", className)}
    />
  );
}
